import { render, staticRenderFns } from "./RoleBindings.vue?vue&type=template&id=67b9abef&scoped=true&"
import script from "./RoleBindings.vue?vue&type=script&lang=js&"
export * from "./RoleBindings.vue?vue&type=script&lang=js&"
import style0 from "./RoleBindings.vue?vue&type=style&index=0&id=67b9abef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9abef",
  null
  
)

export default component.exports